import { AppBar, Box, Container, Toolbar, Typography, Button } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PetsIcon from '@mui/icons-material/Pets';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Новый приём' },
    { path: '/history', label: 'История приёмов' },
  ];

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', pb: 4 }}>
      <AppBar position="static" elevation={0} sx={{ bgcolor: 'background.paper', mb: 3 }}>
        <Container maxWidth="md">
          <Toolbar disableGutters>
            <PetsIcon sx={{ color: 'primary.main', mr: 1 }} />
            <Typography variant="h6" component="div" sx={{ flexGrow: 1, color: 'text.primary', fontWeight: 600 }}>
              Ветеринарный ассистент
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              {navItems.map((item) => (
                <Button
                  key={item.path}
                  component={RouterLink}
                  to={item.path}
                  variant={(item.path === '/history' ? location.pathname.startsWith('/history') : location.pathname === item.path) ? 'contained' : 'text'}
                  sx={{
                    borderRadius: 2,
                    color: (item.path === '/history' ? location.pathname.startsWith('/history') : location.pathname === item.path) ? 'white' : 'text.primary',
                  }}
                >
                  {item.label}
                </Button>
              ))}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      <Container maxWidth="md">
        {children}

        <Box sx={{ textAlign: 'center', mt: 4, color: 'text.secondary' }}>
          <Typography variant="body2">
            Вспомогательный инструмент. Окончательный диагноз и лечение определяет ветеринарный врач.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
